import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { apiEndPoints } from "../constants/api-endpointsconstant";
import { StoreService } from "./store.service";
import { Router } from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class UserService {
    constructor(
        private apiServive: ApiService,
        private storeService: StoreService,
        private router: Router,
    ) { 
       
    }

    getUserInfo(UserId:any){
        let url = `${environment.umsUrl}${apiEndPoints.users}?user_ids=${UserId}`;
        return this.apiServive.get(url, true);
    }

    login(body: any): Observable<any> {
        let url: string = `${environment.umsUrl}${apiEndPoints.login}`;
        return this.apiServive.post(url, body, true);
    }
    notification(body: any): Observable<any> {
        let url: string = `${environment.umsUrl}${apiEndPoints.notification}`;
        return this.apiServive.post(url, body, true);
    }

    otpVerify(body: any): Observable<any> {
        let url: string = `${environment.umsUrl}${apiEndPoints.verify}`;
        return this.apiServive.post(url, body, true);
    }

    resetPassword(body: any): Observable<any> {
        let url: string = `${environment.umsUrl}${apiEndPoints.reset_password}`;
        return this.apiServive.patch(url, body, true);
    }
    
    updatePassword(body:any) {
        let url = `${environment.umsUrl}${apiEndPoints.changePassword}`;
        return this.apiServive.post(url, body, true);
      }

    userLogout(val: boolean = false) {
        let url = `${environment.umsUrl}${apiEndPoints.logout}?all_device=${val}`;
        this.apiServive.get(url, true).subscribe({})
        this.storeService.clearAll();
        this.router.navigate(['/'])
    }
    /**
     * If user session expired from backend then clear localstorage
     */
    sessionExpired(){
        this.storeService.clearAll();
        this.router.navigate(['/'])
    }

    getAPIKey(company_id:number){
        let url = `${environment.umsUrl}${apiEndPoints.apikeys}?application_id=${environment.umsApp_id}&company_id=${company_id}`;
        return this.apiServive.get(url, true);
    }

    getToken(company_id:number){
        let url = `${environment.umsUrl}${apiEndPoints.generateToken}?application_id=${environment.umsApp_id}&company_id=${company_id}`;
        return this.apiServive.get(url, true);
    }
    
    getCompanies(companies:string=''){
        let url = `${environment.umsUrl}${apiEndPoints.companies}?status=1&company_name=${companies}`;
        return this.apiServive.get(url, true);
    }

    updateApiKey(body:any){
        let url = `${environment.umsUrl}${apiEndPoints.apikeys}`
        return this.apiServive.patch(url, body, true);
    }
    updateToken(body:any){
        let url = `${environment.umsUrl}${apiEndPoints.generateToken}`
        return this.apiServive.post(url, body, true);
    }
    getAllUserResource(user_id:number){
        let url = `${environment.umsUrl}${apiEndPoints.userResource}?place_id=13&user_id=${user_id}`;
         return this.apiServive.get(url, true);
    }

    getMapSearchedDetail(searchText:string, place_id:number){
        let url = `${environment.marketsUrl}${apiEndPoints.propertySearch}?search_text=${this.safeEncode(searchText)}`;
        return this.apiServive.searchProperty(url, place_id);
    }
    safeEncode(value: string): string {
        const specialChars = /[#%&?=]/;
        if (specialChars.test(value)) {
            return encodeURIComponent(value);
        }
        return value;
    }
}  
